import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { SCALE_OPTIONS } from "utils/constants/slp";
import React from "react";
import RadioCheckBoxIcon from "components/RadioCheckBoxIcon";
import RadioCheckedBoxIcon from "components/RadioCheckedBoxIcon";
import {
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { IAddPersonalSmartGoals } from "utils/interfaces/slp-form";
import { REQUIRED_MARK } from "utils/constants/Messages";

interface IRenderRadioGroupProps {
  register: UseFormRegister<IAddPersonalSmartGoals>;
  setValue: UseFormSetValue<IAddPersonalSmartGoals>;
  watch: UseFormWatch<IAddPersonalSmartGoals>;
  name: keyof IAddPersonalSmartGoals;
  label: string;
  errorMsg: string;
}

const RenderRadioGroup: React.FC<IRenderRadioGroupProps> = (props) => {
  const { register, name, watch, setValue, label, errorMsg } = props;
  const selectedValue = watch(name);

  return (
    <>
      <Typography variant="body2" className="gray-text-sm" sx={{ pb: 1 }}>
        {label} {REQUIRED_MARK}
      </Typography>
      <RadioGroup
        row
        value={selectedValue ?? ""}
        onChange={(e) => {
          setValue(name, Number(e.target.value), { shouldValidate: true });
        }}
      >
        {SCALE_OPTIONS.map((value) => (
          <FormControlLabel
            key={value}
            value={value}
            label={value.toString()}
            control={
              <Radio
                {...register(name, {
                  validate: (val) => Number(val) > 0,
                })}
                icon={<RadioCheckBoxIcon />}
                checkedIcon={<RadioCheckedBoxIcon />}
              />
            }
          />
        ))}
      </RadioGroup>
      <Typography color="error" className="slp-goal-error" variant="caption">
        {errorMsg}
      </Typography>
    </>
  );
};

export default RenderRadioGroup;
